export class MachineConfigurationDetailViewComponentController {
  static $inject = [];
}
